import {
  useDetailKey,
  useSegmentsForProcess,
  useVisibleGroups,
} from "../../../utils/customHooks/genericHooks";
import { useFlightTranslation } from "../../../utils/customHooks/useFlightTranslation";
import HubletView from "../../../components/Dashboard/HubletView/HubletView";
import { useIsStorybook } from "utils/customHooks/storyHooks";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import { PnlCategoriesEnum } from "types/enums";
import styled from "styled-components/macro";

export const GridLayoutHubletView = () => {
  const visibleGroups = useVisibleGroups();
  const detailKey = useDetailKey();
  const isStorybook = useIsStorybook();
  const process = visibleGroups?.[0]?.processes?.[isStorybook ? 0 : detailKey];

  const processSegments = useSegmentsForProcess(process?.id);
  const lastSegment = processSegments?.[processSegments.length - 1];

  const isUncollected =
    lastSegment?.pnl.category === PnlCategoriesEnum.uncollected;

  const { translate } = useFlightTranslation();
  return (
    <StyledCardWithControlsGridLayoutHubletView
      title={translate("Process_Status")}
      shouldOverlayTitle={true}
      showCardBorder={isUncollected}
    >
      <HubletView isGridLayout={true} />
    </StyledCardWithControlsGridLayoutHubletView>
  );
};
const StyledCardWithControlsGridLayoutHubletView = styled(CardWithControls)``;
